import { createFileRoute } from '@tanstack/react-router';

import { ProductionPlannerGridView } from '../../features/production-planner/production-planner-grid-view';

// section, breadcrumb ("Production Planner") and layout ("full-height") are
// all inherited from the parent `/production-planner` layout route.
export const Route = createFileRoute('/production-planner/')({
  component: ProductionPlannerGridView,
});
